const pino = require('pino');

const config = {
  browser: {
    disabled:
      process.env.DEPLOYABLE_ENV === 'stage' ||
      process.env.DEPLOYABLE_ENV === 'development'
        ? false
        : true,
  },
  redact: {
    paths: ['err'],
    remove: true,
  },
  // Development: pretty print to console
  ...(process.env.DEPLOYABLE_ENV === 'development' && {
    transport: {
      target: 'pino-pretty',
      options: {
        colorize: true,
        ignore:
          'pid,hostname,path,nw_method,nw_forwarded_for,nw_caller_client_id,nw_request_id',
        singleLine: true, // formats output as a single line
        messageKey: 'message',
        hideObject: false, // hides any objects key in the output
      },
    },
  }),
  timestamp: pino.stdTimeFunctions.isoTime,
  // Verbosity of logs. This file is evaluated during `next build` as well as at
  // runtime, and pino throws on an undefined level, so it needs a default
  // rather than relying on the environment. Set LOG_LEVEL to override.
  level: process.env.LOG_LEVEL || 'debug',
  formatters: {
    level(label) {
      return { level: label };
    },
    log(object) {
      if (object.err && typeof object.err === 'object') {
        // Extract 'digest' and 'stack' from 'err' and move them to the top level
        const { digest, stack, ...rest } = object.err;
        return { ...object, err: rest, pid: digest, message: stack };
      }
      return object;
    },
  },
};

const logger = (defaultConfig) =>
  pino({
    ...defaultConfig,
    config,
  });

module.exports = {
  logger,
  config,
};
